import { css } from "styled-components";

const InputHourContainer = css`
  border: 0;

  .DropdownBoxContainer {
    width: 100%;
  }
`;


export default InputHourContainer;
